import { render, staticRenderFns } from "./InvitationDetailModal.vue?vue&type=template&id=18519c0d&scoped=true"
import script from "./InvitationDetailModal.vue?vue&type=script&lang=js"
export * from "./InvitationDetailModal.vue?vue&type=script&lang=js"
import style0 from "./InvitationDetailModal.vue?vue&type=style&index=0&id=18519c0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18519c0d",
  null
  
)

export default component.exports